import { AuthMainFooter, AuthMainHeader, AuthMainWrapper } from "./Atom"
import ProntoLogo from "../../../assets/images/ProntoLogo.png"
import styles from "../../../styles/Login.module.css"
import { Box, Typography } from "@mui/material"
import Login from "./Login"
import { useSelector } from "react-redux"
import ChangePassword from "./ChangePassword"
import InfoIcon from "@mui/icons-material/Info"
import { useState } from "react"
import VerifyOtp from "./VerifyOtp"
import ForgotPassword from "./ForgotPassword"
import ChangeMyPassword from "./ChangeMyPassword"
import TermsOfService from "../../components/Modal/TermsOfService"
import { useLocation } from "react-router-dom"

type Props = {}

const AuthMain = (props: any) => {
  const location = useLocation()
  const {
    loading,
    user,
    email,
    setEmail,
    password,
    setPassword,
    setNewPassword,
    setConfirmNewPassword,
    otp,
    setOtp,
    handleLogin,
    handleCreatePassword,
    handleVerifyEmail,
    emailError,
    passwordError,
    newPasswordError,
    confirmNewPasswordError,
    page,
    forgotEmail,
    setForgotEmail,
    forgotEmailError,
    handleForgotPassword,
    setResetEmail,
    setResetPassword,
    resetEmailError,
    resetPasswordError,
    setResetNewPassword,
    setResetNewConfirmPassword,
    resetNewPasswordError,
    resetNewConfirmPasswordError,
    resetOtp,
    setResetOtp,
    handleResetPasswordOtp,
    handleResetPassword,
    setChangeOldPassword,
    setChangeNewPassword,
    setChangeNewConfirmPassword,
    changeOldPasswordError,
    changeNewPasswordError,
    changeNewConfirmPasswordError,
    handleChangePassword,
  } = props

  const authState = useSelector((state: any) => {
    return state.app.authState
  })
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  return (
    <AuthMainWrapper>
      <AuthMainHeader>
        {/* <Box sx={{ padding: "0 10px" }}>
              <ProntoLogoIcon />
              <img height={"30px"} src={ProntoLogoIcon} alt="" />
            </Box> */}
        {/* <Box>
              <Typography fontSize={`34px`} fontWeight={`900`} className={styles.LoginHeadingText}>PRONTO</Typography>
              <h5 className={styles.LoginSubHeadingText}>Advisory</h5>
            </Box> */}

        <img height={"80px"} width={"380x"} src={ProntoLogo} alt="" />
      </AuthMainHeader>
      {/* <h3 className={styles.SuperAdminText}>Super Admin</h3> */}

      {page == "createPassword" ? (
        <Box className={styles.InfoText}>
          <InfoIcon />
          <Typography>Please create a password to continue</Typography>
        </Box>
      ) : page == "verifyOtp" ? (
        <Box className={styles.InfoText}>
          <InfoIcon />
          <Typography>OTP has been sent to your email</Typography>
        </Box>
      ) : null}

      {page == "login" ? (
        <Login
          loading={loading}
          setEmail={setEmail}
          setPassword={setPassword}
          handleLogin={handleLogin}
          emailError={emailError}
          passwordError={passwordError}
        />
      ) : page == "createPassword" ? (
        <ChangePassword
          loading={loading}
          type="create"
          email={email}
          password={password}
          setNewPassword={setNewPassword}
          setConfirmNewPassword={setConfirmNewPassword}
          newPasswordError={newPasswordError}
          confirmNewPasswordError={confirmNewPasswordError}
          handleChangePassword={handleCreatePassword}
        />
      ) : page == "verifyEmail" ? (
        <VerifyOtp
          loading={loading}
          email={email}
          password={password}
          otp={otp}
          setOtp={setOtp}
          handleSubmit={handleVerifyEmail}
        />
      ) : page == "forgotPassword" ? (
        <ForgotPassword
          loading={loading}
          setForgotEmail={setForgotEmail}
          forgotEmailError={forgotEmailError}
          handleForgotPassword={handleForgotPassword}
        />
      ) : page == "verifyResetPassword" ? (
        <VerifyOtp
          loading={loading}
          email={forgotEmail}
          otp={resetOtp}
          setOtp={setResetOtp}
          handleSubmit={handleResetPasswordOtp}
        />
      ) : page == "resetPassword" ? (
        <ChangePassword
          loading={loading}
          type="forgot"
          email={forgotEmail}
          password={password}
          setNewPassword={setResetNewPassword}
          setConfirmNewPassword={setResetNewConfirmPassword}
          newPasswordError={resetNewPasswordError}
          confirmNewPasswordError={resetNewConfirmPasswordError}
          handleChangePassword={handleResetPassword}
        />
      ) : page == "changePassword" ? (
        <ChangeMyPassword
          loading={loading}
          setOldPassword={setChangeOldPassword}
          setNewPassword={setChangeNewPassword}
          setConfirmNewPassword={setChangeNewConfirmPassword}
          oldPasswordError={changeOldPasswordError}
          newPasswordError={changeNewPasswordError}
          confirmNewPasswordError={changeNewConfirmPasswordError}
          handleChangePassword={handleChangePassword}
        />
      ) : null}
      {location.pathname === "/auth" ? (
        <AuthMainFooter>
          <Typography fontSize={10}>
            By clicking the “ Login” button, you agree to{" "}
            <span className={styles.termsText} onClick={handleOpen}>
              Terms of Service{" "}
            </span>
            & your consent to receiving email communication from{" "}
            <span className={styles.prontoText}>PRONTO</span>
          </Typography>
        </AuthMainFooter>
      ) : (
        ""
      )}

      <TermsOfService
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
    </AuthMainWrapper>
  )
}

export default AuthMain
